module.exports = __webpack_public_path__ + "img/product_17.2320f9d.webp";